import React from 'react';
import amex from 'assets/images/american-express.svg';
import { SvgIconProps } from '@mui/material';

export const AfAmericanExpressIcon: React.FC<SvgIconProps> = () => {
  return <img src={amex} />;
};
